import React from "react";

const LinkIcon2 = ({ color = "var(--border)", width = 24, height = 24 }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 512 512">
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1_copy_4" data-name="Layer 1 copy 4">
          <g id="_53" data-name="53">
            <path
              fill={color}
              d="M413.89,0H98.11A98.1,98.1,0,0,0,0,98.11V413.89A98.1,98.1,0,0,0,98.11,512H413.89A98.1,98.1,0,0,0,512,413.89V98.11A98.1,98.1,0,0,0,413.89,0ZM241.3,374.59l-38.53,38.52a27,27,0,0,1-38.14,0L98.89,347.37a27,27,0,0,1,0-38.14L216.1,192a27,27,0,0,1,38.14,0l45.65,45.65a8.09,8.09,0,0,1-11.44,11.44L242.8,203.47a10.77,10.77,0,0,0-15.26,0L110.33,320.67a10.81,10.81,0,0,0,0,15.27l65.74,65.73a10.81,10.81,0,0,0,15.27,0l38.52-38.52a8.09,8.09,0,0,1,11.44,11.44ZM413.11,202.78,295.9,320a27,27,0,0,1-38.14,0l-45.65-45.65a8.09,8.09,0,0,1,11.44-11.44l45.65,45.65a10.8,10.8,0,0,0,15.26,0L401.67,191.34a10.8,10.8,0,0,0,0-15.26l-65.74-65.74a10.8,10.8,0,0,0-15.27,0l-38.52,38.52a8.09,8.09,0,1,1-11.44-11.44L309.23,98.9a27,27,0,0,1,38.14,0l65.74,65.74A27,27,0,0,1,413.11,202.78Z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default LinkIcon2;
